<template>
  <div>  
    <b-modal id="modal_lopd" size="lg" class="fondo-backdrop"
        title="Acceso / LOPD" 
        content-class="shadow"
        no-close-on-backdrop no-close-on-esc hide-header-close
        button-size="sm" centered ok-title="Aceptar" cancel-title="Cancelar" ok-variant="outline-success" cancel-variant="outline-danger"
        @ok="aceptar" 
        @cancel="cancelar">

        <div class="texto-lopd p-2">
            <p>El responsable del tratamiento de los datos de caracter personal que nos ha suministrado a traves de la solicitud
                para participar en el Plan de Vacaciones de Empleados, hijos de empleados y cursos de idiomas es la <b>Comisión de Fondos Sociales</b>
                con la única finalidad de prestarle el sercicio solicitado. En el caso de que fuera adjudicatario de algunas de las plazas, en cualquiera
                de las distintas modalidades que se ofertan, deberá realizar la facturación de las mismas a traves del dominio de internet<br><b>www.fondos-sociales.com</b>
            </p>
            <p>Con objeto de mantenerle informado, y en el que caso de que nos de su consentimiento, le enviaremos publicidad relacionada con los planes anteriormente señalados,
                asi como de productos y servicios relacionados con los mimos a través de correo postal, electrónico o telefónico.
            </p>
            <p>Los datos proporcionados se conservaran mientras no solicte el cese de la actividad, se mantenga la relación comercial o durante los años necesarios
                para cumplir con las obligaciones legales.<br>Los datos no se cederán a terceros salvo los casos en que exista una obligación legal.
            </p>
            <p>En todo momento, usted podrá, ejercer los derechos de rectificación y supresión de sus datos enviando un correo electrónico a <b>rgpd@fondos-sociales.com</b>.            
            </p>
            <p><i><b>Nota:</b>
                puede consultar toda la información detallada sobre la ley de protección de datos haciendo click en el siguiente enlace.</i>
                <a href="https://fondos-sociales.com/pdf/privacidad.pdf" target="_blank">
                    <button class="ml-3 mt-1" size="sm">Politica de Privacidad</button>    
                </a>
            </p>

        </div>
    </b-modal>
  </div>
</template>

<script>

//import login from '@/views/Login.vue'

export default {
  name: 'lopdM',
  components: {
    //login,

  },

  data() {
    return {
    }
  },

  created() {
    // if (this.logueado) {
    //   this.$router.push('/');    
    // }
  },

  computed: {

  },
  methods: {
      close() {
          this.hideModal();    
          //this.$bvModal.hide(this.modal);
      },

      aceptar() {
          //alert('aceptar');
          this.$store.state.auth.lopd=true;


      },
      cancelar() {
          //alert('cancelar');
          this.$store.state.auth.lopd=false;

          this.$store.commit('login_off','Sin autorizar LOPD');
          //this.$router.push('/inicio');
      }
  }
}

</script>

<style>
    .fondo-backdrop {
        opacity:0.7 !important;
    }
    .texto-lopd {        
        font-size: 1rem;
        
        
    }


</style>
